import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const getOutletList = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_LIST}`,{params});
    return response.data;
}


export const getOutletSalutation = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.Cutomer.GET_OUTLET_SALUTATION);
    return response.data;
}

export const getOutletMaritalStatus = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.Cutomer.GET_OUTLET_MARITAL_STATUS);
    return response.data;
}

export const getOutletClassification = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.Cutomer.GET_CLASSIFICATION_LIST);
    return response.data;
}

export const getOutletStatus = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.Cutomer.GET_OUTLET_STATUS);
    return response.data;
}

export const getOutletById = async (outletId?: number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_BY_ID}/${outletId}`);
    return response.data;
}

export const updateOutlet = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET}`, body);
    return response.data;
}

export const addOutlet = async (reqBody:any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_OUTLET}`, reqBody );
    return response.data;
}

export const getTownFilter = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_ALL_TOWNS}`,{params});
    return response.data;
}

export const getAddressType = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_ADDRESS_TYPE}`);
    return response.data;
}


export const getCityStateByTownId = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_CITY_STATE_BY_TOWN}`,{params});
    return response.data;
}

export const getOutletAddressById = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ADDRESS_BY_ID}`,{params});
    return response.data;
}

export const getOutletOrganizationList = async (params?: Record<string, any>, outletId?: number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ORGANIZATION_LIST}/${outletId}`, { params:params });
    return response.data;
}

export const getOutletAddressList = async (params?: Record<string, any>, outletId?: number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ADDRESS_LIST}/${outletId}`, { params:params });
    return response.data;
}

export const addOutletAddress = async (reqBody:any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_OUTLET_ADDRESS}`, reqBody );
    return response.data;
}

export const updateOutletAddress = async (reqBody:any) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_ADDRESS}`, reqBody );
    return response.data;
}


export const getOutletOrganizationDataById = async (params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ORGANIZATION_DATA_BY_ID}`,{params});
    return response.data;
}

export const getOutletVisitFrequency = async (params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_VISIT_FREQUENCY}`);
    return response.data;
}

export const addOutletOrgData = async (body: Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_OUTLET_ORG_DATA}`, body);
    return response.data;
}

export const updateOutletOrgData = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_ORG_DATA}`, body);
    return response.data;
}


export const getOutletMappingList = async (params?: Record<string, any>, outletId?: number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_MAPPING_LIST}/${outletId}`, { params:params });
    return response.data;
}

export const getOutletMappingById = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_MAPPING_BY_ID}`,{params});
    return response.data;
}

export const getOutletCategoryTypes = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_CATEGORY_TYPE}`);
    return response.data;
}

export const getOutletParent = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_PARENT}`,{params});
    return response.data;
}

export const getOutletQualificationList = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_QUALIFICATION_LIST}`);
    return response.data;
}

export const updateOutletMapping = async (body: Record<string,any>,params:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_MAPPING}`, body,{params});
    return response.data;
}

export const addOutletMapping = async (reqBody:any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_OUTLET_MAPPING}`, reqBody );
    return response.data;
}

export const getOutletDCRSummary = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_DCR_SUMMARY}/${id}`,{params});
    return response.data;
}

export const getOutletSgpiOutSummary = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_SGPI_OUT_SUMMARY}/${id}`,{params});
    return response.data;
}


export const getOutletRCPASummary = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_RCPA_SUMMARY}/${id}`,{params});
    return response.data;
}

export const getOutletStockList = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_INVENTORY}/${id}`,{params});
    return response.data;
}

export const updateOutletStock = async (id:number,body?:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_INVENTORY}/${id}`,body);
    return response.data;
}

export const updateOutletOrgNote = async (id:number,body?:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_ORG_NOTE}/${id}`,body);
    return response.data;
}

export const addOutletOrgNote = async (id:number,body?:Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_OUTLET_ORG_NOTE}/${id}`,body);
    return response.data;
}

export const getOutletOrgNotesList = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ORG_NOTE_LIST}/${id}`,{params});
    return response.data;
}
export const getOutletOrgNoteById = async (outletOrgDataId:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_OUTLET_ORG_NOTE_BY_ID}/${outletOrgDataId}`,{params});
    return response.data;
}


export const updateBeatOutlet = async (body?:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_BEAT_OUTLET}`,body);
    return response.data;
}

export const addBeatOutlet = async (body?:Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.Cutomer.ADD_BEAT_OUTLET}`,body);
    return response.data;
}

export const getBeatOutletList = async (id:number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_BEAT_OUTLET_LIST}/${id}`,{params});
    return response.data;
}
export const getBeatOutletById = async (params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_BEAT_OUTLET_BY_ID}`,{params});
    return response.data;
}

export const getBeatOutletStatus = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Cutomer.GET_BEAT_OUTLET_STATUS}`);
    return response.data;
}